import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { catchError, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { of } from 'rxjs';
import { RequestUpdateService } from '../services/sections/job/request-update.service';

@Injectable({
	providedIn: 'root'
})
export class RequestUpdateResolver implements Resolve<Map<number, number>> {
	constructor(
		private requestUpdateService: RequestUpdateService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.requestUpdateService.getLastRequestUpdateChoiceForStaffMembers(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return of([]);
				}),
				map(result => {
					const dictionary = new Map<number, number>();
					result?.forEach(item => dictionary.set(item.id, item.name));
					return dictionary;
				})
			);
	}
}
